<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import Swal from "sweetalert2";
import axios from "axios";
import { API_URL } from "@/core/api";
// import { initFbsdk } from "@/core/config/facebook.js";
import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import {
  ArrowUpIcon,
  UserIcon,
  MailIcon,
  BookIcon,
  MessageCircleIcon,
} from "vue-feather-icons";

import Navbar from "@/view/front/components/navbar";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";

/**
 * Page-contact-one component
 */
export default {
  data() {
    return {
      state: "signin",
      form: {
        email: "",
        password: "",
      },
      apiUrl: API_URL,
    };
  },
  components: {
    Navbar,
    Switcher,
    Footer,
    UserIcon,
    ArrowUpIcon,
    MailIcon,
    BookIcon,
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
  },
  methods: {},
  metaInfo: function () {
    return {
      title: "Thank you for contacting us - job4u.pk",
      meta: [
        {
          name: "description",
          content:
            "Thank you for contacting us. One of our team members will be in touch soon.",
        },
      ],
    };
  },
};
</script>

<template>
  <div>
    <Navbar />
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg
          viewBox="0 0 2880 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <section class="mt-30" >
      <div class="container">
        <div class="jumbotron text-center bg-white" style="min-height: 50vh;">
          <h1 class="display-3">Thank You</h1>
          <p class="lead">
            <strong> for contacting us. One of our team members will be in touch soon.</strong> 
          </p>
          <hr />
          <!-- <p>Having trouble? <a href="">Contact us</a></p> -->
          <p class="lead">
            <a
              class="btn btn-primary btn-sm"
              href="/"
              role="button"
              >Go back to homepage</a
            >
          </p>
        </div>
      </div>
    </section>
    <Footer />
    <Switcher />
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
  </div>
</template>
